import { useState } from 'react'
import styled from '@emotion/styled'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { colors } from '@global/constants'
import styles from './login.module.css'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'

const StyledButton = styled(Button)`
  margin-top: 12px;
  position: relative;
  float: right;
`

const SpacedTypography = styled(Typography)`
  margin-top: 36px;
  margin-bottom: 12px;
`

// $1 = protocol, $2 = (2nd - nth) subdomain + domain + TLD
const subdomainRegex = /(https?:\/\/)(?:[a-z0-9-]+[.])*(claravine\.[a-z0-9-]+(?:[.][a-z]+)?)/

export const DomainFirstLogin = () => {
  const [domain, setDomain] = useState('')
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const location = window.location.href

    window.location.assign(location.replace(subdomainRegex, `$1${domain}.$2`))
  }
  const exampleDomain = `${new URL(window.location.href.replace(subdomainRegex, `$1${domain || 'example'}.$2`)).origin}/`
  return (
    <div className={styles.background}>
      <div className={styles.content}>
        <div className={styles.left}>
          <div>
            <img alt={t`Claravine`} style={{ maxWidth: '200px' }} src="/images/logo_dark.png" />
          </div>
          <div className={styles.boxUnderImg} />
          <div style={{ marginTop: 5 }}>
            <Typography
              variant="h6"
              gutterBottom
              style={{
                lineHeight: '15px',
                paddingTop: '5px',
                margin: 0,
                fontWeight: '400',
                color: colors.gray.medium,
              }}
            >
              <Trans>Data integrity starts with standards</Trans>
            </Typography>
            <SpacedTypography variant="body2">
              <Trans>Login to your Claravine account at {exampleDomain}</Trans>
            </SpacedTypography>
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                variant="outlined"
                value={domain}
                label={t`Domain`}
                onChange={({ target: { value } }) => {
                  setDomain(value)
                }}
              />
              <StyledButton color="primary" variant="contained" type="submit">
                <Trans>Continue</Trans>
              </StyledButton>
            </form>
          </div>
        </div>
        <div className={styles.right}>
          <img
            alt={t`Claravine Login`}
            src="https://claravine-public-prod.s3-us-west-2.amazonaws.com/images/login_image_data_standards_small.jpg"
            className={styles.loginImg}
          />
        </div>
      </div>
    </div>
  )
}
